const FinancialTableEmptyRow = () => {
  return <tr className="financialstatementstablerowbreak"></tr>;
};

export default FinancialTableEmptyRow;